import { useTranslation } from "react-i18next";
import LegalPage from "@/components/LegalPage";

export default function Terms() {
  const { t } = useTranslation();
  const keys = ["scope", "risk", "content", "user_conduct", "contact_form", "changes", "law"];
  return (
    <LegalPage
      title={t("pages.terms.title")}
      updated={t("pages.terms.updated")}
      intro={t("pages.terms.intro")}
      sectionKeys={keys}
      i18nRoot="pages.terms.sections"
      testIdRoot="terms"
    />
  );
}
